import type { ExperimentEvent, ExperimentState } from "../types";

const STATE_KEY = "main-experiment-test-state-v1";
const EVENT_KEY = "main-experiment-test-events-v1";

export function loadState(): ExperimentState | null {
  try {
    const value = localStorage.getItem(STATE_KEY);
    return value ? (JSON.parse(value) as ExperimentState) : null;
  } catch {
    return null;
  }
}

export function saveStateLocally(state: ExperimentState) {
  localStorage.setItem(STATE_KEY, JSON.stringify(state));
}

export function appendEventLocally(event: ExperimentEvent) {
  const current = getLocalEvents();
  current.push(event);
  localStorage.setItem(EVENT_KEY, JSON.stringify(current.slice(-3000)));
}

export function getLocalEvents(): ExperimentEvent[] {
  try {
    const value = localStorage.getItem(EVENT_KEY);
    return value ? (JSON.parse(value) as ExperimentEvent[]) : [];
  } catch {
    return [];
  }
}

export function resetLocalPrototype() {
  localStorage.removeItem(STATE_KEY);
  localStorage.removeItem(EVENT_KEY);
}

export async function persistRemoteState(state: ExperimentState) {
  const response = await fetch("/api/state", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ state }),
  });
  if (!response.ok) throw new Error("remote-state-save-failed");
}

export async function persistRemoteEvent(event: ExperimentEvent) {
  const response = await fetch("/api/events", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ event }),
  });
  if (!response.ok) throw new Error("remote-event-save-failed");
}
